import React from "react";

import { ItemText, MenuListItem } from "../MultiLevelMenu";
import { searchTabProp } from "../utilities";

const SalesRentalsMenu = () => (
  <>
    <MenuListItem isFullSize>
      <ItemText href="/" isBig {...searchTabProp("sales", "/")}>
        Sales
      </ItemText>
    </MenuListItem>
    <MenuListItem isFullSize>
      <ItemText href="/" isBig {...searchTabProp("rentals", "/")}>
        Rentals
      </ItemText>
    </MenuListItem>
  </>
);

SalesRentalsMenu.propTypes = {};

SalesRentalsMenu.defaultProps = {};

export default SalesRentalsMenu;
